var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-space',{attrs:{"direction":"vertical","size":1}},[(_vm.codeContent)?_c('vue-qrcode',{staticClass:"receipt-card-item--qr-code",attrs:{"value":_vm.codeContent}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"trawl-text-bolder",style:({ 'font-size': '.55rem' })},[_vm._v("No Barang: "+_vm._s(_vm.codeContent))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }